import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { applyFormConfig } from '@wz-utilities/form.utilities';
import { WzValidators } from '@wz-validators';
import { RegexConstants } from 'libs/constants/regex-constants';
import {
  FormGroupBaseComponent,
  getFormGroupBaseDirective,
} from 'libs/modules/tunnelsante-forms/components/form-group-base.component';
import { AddressModels } from 'models/address.models';
import { CommonRiskModels } from 'models/common-risk.models';
import { FormConfigModels } from 'models/form-config.models';
import { AgencyModels } from '../../../../../../models/agency.models';
import AgencyDetails = AgencyModels.AgencyDetails;

@Component({
  selector: 'wz-assure-info-form',
  templateUrl: './assure-info-form.component.html',
  styleUrls: ['./assure-info-form.component.scss'],
  providers: [getFormGroupBaseDirective(AssureInfoFormComponent)],
  standalone: false,
})
export class AssureInfoFormComponent
  extends FormGroupBaseComponent<CommonRiskModels.AssureInfos>
  implements OnChanges
{
  get agencyDetails(): AgencyModels.AgencyDetails {
    return this._agencyDetails;
  }

  @Output() assureInfoChange = new EventEmitter<number>();

  @Input() set agencyDetails(value: AgencyModels.AgencyDetails) {
    this._agencyDetails = value;
  }
  nomCtrl!: FormControl;
  prenomCtrl!: FormControl;
  mobileCtrl!: FormControl;
  phoneCtrl!: FormControl;
  emailCtrl!: FormControl;
  civiliteCtrl!: FormControl;
  immatriculationCtrl!: FormControl;

  @Input() config!: FormConfigModels.AssureInfoConfig;

  private _agencyDetails!: AgencyDetails;

  @Input() addressRepository: 'wazari' | 'smalltox' | undefined = undefined;

  @Output() zipCodeChange: any = new EventEmitter<string>();

  public forTunnelApp = false;

  constructor(private fb: FormBuilder) {
    super();
    this.formGroup = this.createForm();
  }

  private createForm() {
    this.nomCtrl = this.fb.control(null, [
      Validators.required,
      Validators.pattern(RegexConstants.Name),
    ]);
    this.prenomCtrl = this.fb.control(null, [
      Validators.required,
      Validators.pattern(RegexConstants.Name),
    ]);
    this.emailCtrl = this.fb.control(null, [
      Validators.required,
      this.EmailNotBrokerValidator.bind(this),
    ]);
    this.phoneCtrl = this.fb.control(null);
    this.mobileCtrl = this.fb.control(null);
    this.civiliteCtrl = this.fb.control(null, [Validators.required]);
    this.immatriculationCtrl = this.fb.control(null);

    const addressCtrl = this.fb.control<AddressModels.Address | any>(null, [
      Validators.required,
    ]);

    const group = this.fb.group(
      {
        civilite: this.civiliteCtrl,
        nom: this.nomCtrl,
        prenom: this.prenomCtrl,
        address: addressCtrl,
        email: this.emailCtrl,
        phone: this.phoneCtrl,
        mobile: this.mobileCtrl,
        immatriculation: this.immatriculationCtrl,
      },
      {
        validator: [WzValidators.atLeastOneRequired('phone', 'mobile')],
      },
    );

    addressCtrl.valueChanges.subscribe((ad: AddressModels.Address) => {
      this.zipCodeChange.next(ad ? ad.cityZipCode : '');
    });

    return group;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['config']) {
      applyFormConfig(this.formGroup, this.config);
    }
  }

  EmailNotBrokerValidator: ValidatorFn = (control) => {
    return this._agencyDetails &&
      control.value &&
      (control.value.toLowerCase() ==
        this._agencyDetails.headOfAgency?.email?.toLowerCase() ||
        control.value.toLowerCase() ==
          this._agencyDetails.mainBroker?.brokerEmail?.toLowerCase())
      ? { mailBroker: true }
      : null;
  };

  public customizeForTunnelApp() {
    this.forTunnelApp = true;
  }
}
